module.exports = __webpack_public_path__ + "media/semantic/dist/themes/default/assets/fonts/brand-icons-a06da7f0950f9dd366fc9db9d56d618a.woff2";